'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:HomeController
 * @description
 * # HomeController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('HomeController', ['$rootScope', '$scope', '$location', 'ApplicationService', 'SetupService',  'MainMenu', 'UserInfo', 'FlashService','SignalR',
   function ($rootScope, $scope, $location, ApplicationService, SetupService,  MainMenu, UserInfo, FlashService,SignalR) {

      var applicationId = null;

      $scope.tiles = [];
      FlashService.ShowProgressBar();
      
      $scope.closeSignalRConnection = function () {
          SignalR.Stop();
      };

      $scope.$on('$destroy', function () {
          $scope.closeSignalRConnection();
      });

      $scope.$on('$routeChangeStart', function () {
          $scope.closeSignalRConnection();
      });

      $scope.setTile = function ($event, option) {
          $event.stopPropagation();
          MainMenu.Navigate(option, applicationId);
      };

      $(document).ready(function () {
          $('[data-toggle="tooltip"]').tooltip();
      });

      function init() {
          UserInfo.GetUserInfo().then(function (user) {

              if (!user.selectedApp) {
                  $scope.dataLoaded = true;
                  return;
              }

              applicationId = user.selectedApp.id;

              MainMenu.GetMenu(applicationId).then(function (data) {
                  $scope.tiles = data.tiles;

                  if (data.withoutRefresh) {
                      refreshTiles();
                }

                  // this Hub has been hidden due to performance issues
                  /*SignalR.StartConnection(function(callBack) {
                      refreshTiles(callBack);
                  }, '/HomePageTile');*/
              });
          });
         
      }

      function refreshTiles(data) {

          var requestData = getRequestData(data);

          ApplicationService.RefreshAppOptionTiles(requestData).then(function (response) {

              response.data.forEach(function (newTileContent) {
                  $scope.tiles[newTileContent.tileType].forEach(function (tile) {
                      if (tile.id === newTileContent.applicationOptionId) {
                          tile.homeTileContent = newTileContent;
                          tile.tileChanging = false;
                      }
                  });     
              });

              $scope.dataLoaded = true;
              FlashService.HideProgressBar();
          });

      }

      function getRequestData(data) {

          if (data) {
              $scope.tiles.actions.forEach(function (tile) {
                  data.applicationOptions.forEach(function (newTileContent) {
                      if (tile.id === newTileContent.appOptId) {
                          tile.tileChanging = true;
                      }
                  });
              });

              $scope.tiles.boards.forEach(function (tile) {
                  data.dashboards.forEach(function (newTileContent) {
                      if (tile.id === newTileContent.appOptId) {
                          tile.tileChanging = true;
                      }
                  });
              });
          } else {
              $scope.dataLoaded = false;
              data = { applicationOptions: [], dashboards: [] };

              $scope.tiles.actions.forEach(function (tile) {
                  data.applicationOptions.push({
                      appId: applicationId,
                      appOptId: tile.id
                  });
                  tile.tileChanging = true;
              });

              $scope.tiles.boards.forEach(function (tile) {
                  data.dashboards.push({
                      appId: applicationId,
                      appOptId: tile.id
                  });
                  tile.tileChanging = true;
              });
          }

          return data;
      }

      $rootScope.$watch('userDataLoaded',
          function (value) {
              if (!value) {
                  return;
              }
              init();
          });

  }]);
